export const trackClickedAttr = 'data-trk';

export type TrackClickedData = {
  name: string;
  properties?: Record<string, string | number | null | undefined>;
};

/**
 * There is no snippet for trackClicked because it is not used directly,
 * but rather via RichDetails and ClickActions
 */
export function trackClickedAttributes(data: TrackClickedData | undefined) {
  if (!data) return {};

  const attributes: Record<string, string> = {
    [trackClickedAttr]: data.name,
  };

  if (data.properties) {
    for (const [key, value] of Object.entries(data.properties)) {
      if (typeof value === 'undefined' || value === null) continue;

      attributes[`${trackClickedAttr}-${key}`] = value.toString();
    }
  }

  return attributes;
}
